import React, { useContext } from 'react';
import { useHistory } from 'react-router-dom';
import {
  Card,
  CardHeaderNumber,
  CardContentLine,
} from './MetricsCard';
import * as Price from '../util/Price';
import colors from '../styles/colors';
import { getFilteredContacts } from '../util/customersUtil';
import {
  DashboardFilteresTypes,
  DashboardFiltersSubTypes,
} from '../util/CustomerFilterEnum';
import { AppContext } from '../context/AppContext';
import useMutateAnalytics from '../util/mutate.Analytics';
import analyticsKeys from "../util/UsageStatLinks";

export default function CreditRedeemedCard({ metrics, timeRange }) {
  
  const { setApp } = useContext(AppContext);
  const history = useHistory();
  const mutateAnalytics = useMutateAnalytics()

  const isNewClickable = metrics?.creditRedeemedNew > 0;
  const isReturningClickable = metrics?.creditRedeemedRepeat > 0;
  const isReferrersClickable = metrics?.creditRedeemedAffiliate > 0;
  
  const onClickHandler = (subType) => getFilteredContacts(setApp, history, {
    type: DashboardFilteresTypes.CreditRedeemed,
    subType,
    ...timeRange,
  });

  return (
    <Card title="Credit Redeemed">
      <CardHeaderNumber>{`$${Price.output(metrics?.creditRedeemedTotal, true)}`}</CardHeaderNumber>
      <CardContentLine
        left="New Customers"
        right={`$${Price.output(metrics?.creditRedeemedNew, true)}`}
        color={isNewClickable ? colors.seaGreen : colors.grey2}
        onClick={isNewClickable ? () => {
          const mutateAnalyticsVariables = {
            link: analyticsKeys.DASHBOARD_CREDIT_REDEEMED_NEW_CUSTOMER,
          };
          mutateAnalytics(mutateAnalyticsVariables);
          onClickHandler(DashboardFiltersSubTypes.New);
        } : null}
      />
      <CardContentLine
        left="Returning Customers"
        right={`$${Price.output(metrics?.creditRedeemedRepeat, true)}`}
        color={isReturningClickable ? colors.seaGreen : colors.grey2}
        onClick={isReturningClickable ? () =>  {
          const mutateAnalyticsVariables = {
            link: analyticsKeys.DASHBOARD_CREDIT_REDEEMED_RETURNING_CUSTOMER,
          };
          mutateAnalytics(mutateAnalyticsVariables);
          onClickHandler(DashboardFiltersSubTypes.Returning);
        } : null}
      />
      <CardContentLine
        left="Referrers"
        right={`$${Price.output(metrics?.creditRedeemedAffiliate, true)}`}
        color={isReferrersClickable ? colors.seaGreen : colors.grey2}
        onClick={isReferrersClickable ? () =>  {
          const mutateAnalyticsVariables = {
            link: analyticsKeys.DASHBOARD_CREDIT_REDEEMED_REFERRERS_CUSTOMER,
          };
          mutateAnalytics(mutateAnalyticsVariables);
          onClickHandler(DashboardFiltersSubTypes.Referrers);
        } : null}
      />
    </Card>
  );
}
